if(typeof Mixins == 'undefined'){
    window.Mixins = {};
}
